/**
 * Application Version Management
 * Single source of truth for version information
 *
 * IMPORTANT: When updating version, ONLY modify this file
 * AUTO-BUILD ENABLED: Changes trigger automatic rebuild
 */

export const APP_VERSION = "7.9.21";

export const VERSION_INFO = {
  version: APP_VERSION,
  latestModifications: "Admin settings: EPRS login can be edited and tested; images served from images.celltop.vip; Hot cards no longer show the product code.",
  features: [
    "Performance optimized pages (Home, Gaming, Gift Cards, Bills)",
    "Mobile-ready with responsive hooks",
    "Firebase notifications (login-based)",
    "Jawwal invoice printing",
    "Siri voice integration",
    "Arabic audio pronunciation",
    "Mada enquiry response handling"
  ]
};

export const getVersionString = () => `v${APP_VERSION}`;
export const getCSSVersionString = () => `V_${APP_VERSION}`;
export const getVersionHeader = () => APP_VERSION;

export default APP_VERSION;
